import { render, staticRenderFns } from "./VehicleShipmentForm.vue?vue&type=template&id=a50a9c50&scoped=true&"
import script from "./VehicleShipmentForm.vue?vue&type=script&lang=js&"
export * from "./VehicleShipmentForm.vue?vue&type=script&lang=js&"
import style0 from "./VehicleShipmentForm.vue?vue&type=style&index=0&id=a50a9c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50a9c50",
  null
  
)

export default component.exports